<script lang="ts">
  import type { Snippet } from 'svelte';

  interface Props {
    name?: string;
    expanded?: boolean;
    onclick?: () => void;
    className?: string;
    children: Snippet;
  }

  let { name = '', expanded = false, onclick, className, children }: Props = $props();
</script>

<button
  name="dropdown"
  class={`dropdown ${className}`}
  id={`${name}-dropdown`}
  {onclick}
  type="button"
  aria-controls={`${name}-dropdown-menu`}
  aria-expanded={expanded}
>
  {@render children()}
</button>

<style lang="scss">
  @import 'src/scss/media';

  .dropdown {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0;
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
    color: inherit;
    background-color: inherit;
    text-transform: inherit;
    outline: none;
    border: none;
    cursor: pointer;

    @include at(lg) {
      align-items: flex-end;
    }
  }
</style>
